var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44563 14.4181L15.8077 5.56596C16.3106 5.05981 16.5901 4.37938 16.5858 3.67213C16.5815 2.96488 16.2936 2.28779 15.7846 1.78762C15.2757 1.28744 14.5865 1.00448 13.8667 1.00005C13.1468 0.995625 12.4541 1.27009 11.9388 1.76397L2.34701 11.1595C1.47914 12.0261 0.995 13.1946 1.00004 14.4103C1.00508 15.626 1.49889 16.7906 2.37391 17.6502C3.24894 18.5099 4.43427 18.995 5.67173 19C6.90919 19.0049 8.09851 18.5293 8.98063 17.6766L17 9.80959",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.534402735187b71197f2952b92a98a7a.svg";
export { ForwardRef as ReactComponent };